export default __webpack_public_path__ + "static/media/search_grey.ea0e3be6.svg";